// The screen a sign-in passes through: an app's "Sign in with Cloudish"
// (/oauth/authorize, /oauth/logout) and Auth0's return (/auth/callback, see
// App.tsx). No SiteNav or SiteFooter: the visitor came from someone else's
// app and is on their way back to it, so it's a card with the Cloudish mark,
// like any provider's sign-in screen, not a page of the marketing site. The
// mark isn't a link, so there's nothing to wander off through mid-sign-in.

import type { ReactNode } from 'react';
import { Logo } from './Logo';

export function SignInScreen({ children }: { children: ReactNode }) {
  return (
    <div className="auth-screen auth-screen-bare">
      <div className="auth-card">
        <div className="auth-logo">
          <Logo height={22} />
        </div>
        {children}
      </div>
    </div>
  );
}

export default SignInScreen;
